<template>
  <v-btn text @click="onClick" v-bind="$attrs">
    <v-icon left>mdi-close</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
import {RouterUtils} from '../utils/router-utils';

export default {
  name: 'CancelButton',
  mixins: [
    RouterUtils
  ],
  props: {
    label: {
      type: String,
      default () {
        return this.$t('general.cancel');
      }
    }
  },
  computed: {
    hasClickListener (){
      return this.$listeners && this.$listeners.click
    }
  },
  methods: {
    onClick () {
      if (this.hasClickListener) {
        this.$emit('click');
      } else {
        this.routerBack();
      }
    }
  }
}
</script>
